import React, { useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import {
  StyledModal,
  StyledInnerContainer,
  StyledColumns,
  StyledCloseButton,
  StyledCloseIcon,
  StyledUserStory,
  ImgContainer,
  StyledFlex,
} from './UserContentModal.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

interface UserContent {
  title: string;
  excerpt: string;
  mediaLink: string;
  registryProducts: { imageUrl: string }[];
}

interface UserContentModalProps {
  isModalOpen: boolean;
  userContent: UserContent;
  handleClose: () => void;
}

const UserContentModal: React.FC<UserContentModalProps> = ({ isModalOpen, userContent, handleClose }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  return (
    <StyledModal
      isOpen={isModalOpen}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      ariaHideApp={false}
      style={{
        overlay: {
          background: 'rgba(0, 0, 0, 0.25)',
          zIndex: 101,
          overflow: 'hidden',
        },
        content: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          overflow: 'hidden',
        },
      }}
    >
      <StyledInnerContainer ref={containerRef} alignItems="center" justifyContent="center">
        <StyledColumns>
          <Flex flexDirection="column" paddingX={[0, 4]}>
            <Box marginBottom={[4, 7]}>
              <Text color="neutra6" variant="hed40" tagName="div" textAlign="center" marginTop={[6, 8]}>
                {`${ReactHtmlParser(userContent.title)} Story`}
              </Text>
            </Box>
            <Flex>
              <StyledCloseButton
                id="experiments-modal-close"
                variant="altPurpleSecondary"
                onClick={handleClose}
                skipRedirectWithTelemetry={true}
              >
                <StyledCloseIcon name="notAttending" color="mono1" />
              </StyledCloseButton>
            </Flex>
            <StyledFlex>
              <StyledUserStory color="neutra5" variant="dek20" tagName="div">
                {ReactHtmlParser(userContent.excerpt)}
              </StyledUserStory>
              <LazyLoadWrapper>
                <ImgContainer
                  src={cloudAssetUrl(userContent.mediaLink, { optimization: 'default' })}
                  aria-label={`${userContent.title}'s Wedding Registry`}
                />
              </LazyLoadWrapper>
            </StyledFlex>
          </Flex>
        </StyledColumns>
      </StyledInnerContainer>
    </StyledModal>
  );
};

export default UserContentModal;
